import React, { useContext } from 'react';

import Utils from '../utils';
import { UpgradeMessage } from './UpgradeMessage.component';

const { BillingPlans } = Utils;
const { prettyPrintPlan } = BillingPlans;

const UpgradePlanOrdersAndProductsContent = ({ data }) => {
	const { upgradePlan, triggerFeature = 'Orders' } = data;
	const { Name, Price } = upgradePlan;

	const renderPricePanel = () => (
		<div className="price-panel">
			<p className="plan-name">
				<strong>{prettyPrintPlan(Name)} Plan</strong>
			</p>
			<p className="plan-price">
				<strong>${Price}</strong> / month
			</p>
		</div>
	);

	const getPlanFeatures = () => (
		<div className="plan-features">
			<UpgradeMessage>
				<p>
					{triggerFeature} requires the <strong>{prettyPrintPlan(Name)}</strong>{' '}
					Plan
				</p>
			</UpgradeMessage>
			<div className="plan-features-list">
				<p>
					Upgrading to the {prettyPrintPlan(Name)} plan gives you this feature,
					plus:
				</p>
				<ul>
					<li>5 account users</li>
					<li>Barcode scanning and automation</li>
					<li>Customized packing slips and emails</li>
				</ul>
			</div>
			{renderPricePanel()}
		</div>
	);

	const renderPlanInfo = () => {
		if (triggerFeature === 'Orders') {
			return (
				<>
					<p>Manage your ecommerce orders and shipping in the Orders screen:</p>
					<ul>
						<li>Import orders from a store</li>
						<li>Automate shipping selections</li>
						<li>Print packing slips</li>
					</ul>
					{getPlanFeatures()}
				</>
			);
		} else {
			return (
				<>
					<p>Create a Product catalog so you can:</p>
					<ul>
						<li>Add product details to packing slips & emails</li>
						<li>Create default shipping settings</li>
						<li>Automate customs declarations</li>
					</ul>
					{getPlanFeatures()}
				</>
			);
		}
	};

	return (
		<div className="orders-products-upgrade-content">
			<div className="left-content">
				<div className="plan-info">{renderPlanInfo()}</div>
			</div>
		</div>
	);
};

export default UpgradePlanOrdersAndProductsContent;
